<template>
  <section class="flex flex-col gap-4 px-6 py-7 xl:py-4">
    <div v-if="label" class="flex items-center justify-between">
      <slot name="label">
        <SFHeadline
          v-if="label"
          class="!font-semibold capitalize leading-normal"
          size="lg"
          tag="h4"
        >
          {{ label }}
          <span
            :class="{ 'opacity-100': badge > 0 }"
            class="inline-flex h-4 items-center justify-center rounded-full bg-black px-1.5 text-xs leading-4 text-white opacity-0"
            data-testid="filter-group-counter"
          >
            {{ badge }}
          </span>
        </SFHeadline>
      </slot>
      <slot name="action">
        <SFButton
          v-if="badge > 0 || showAction"
          class="rounded bg-gray-100 p-1 text-sm font-medium leading-none !text-gray-600 xl:bg-white xl:hover:translate-x-[-4px] xl:hover:bg-gray-100"
          size="sm"
          variant="raw"
          @click="$emit('clickReset')"
        >
          {{ resetLabel ?? $t('filter_group.reset') }}
        </SFButton>
      </slot>
    </div>
    <div>
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { SFButton, SFHeadline } from '#storefront-ui/components'

const {
  resetLabel,
  label = '',
  badge = 0,
  showAction = false,
} = defineProps<{
  label?: string
  resetLabel?: string
  badge?: number
  showAction?: boolean
}>()

defineEmits<{ clickReset: [] }>()
</script>
